/**
 * Detect the first URL in a text string.
 * Mirrors iOS URLDetector.firstURL(in:) behavior.
 */

const URL_REGEX = /https?:\/\/[^\s<>"')\]]+/i;

export function firstURL(text: string | null | undefined): string | null {
  if (!text) return null;
  const match = text.match(URL_REGEX);
  return match?.[0] ?? null;
}
